export * from './departments.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/index.ts